// src/components/music/utils/badgeUtils.js

import { MUSIC_TYPES } from '../constants/musicTypes';

export const getTypeLabel = (type) => {
  return MUSIC_TYPES.find(t => t.value === type)?.label || type;
};

export const getTypeBadgeColor = (type) => {
  const colors = {
    'song': 'bg-blue-100 text-blue-800',
    'instrumental': 'bg-green-100 text-green-800',
    'piano': 'bg-purple-100 text-purple-800',
    'minus-one': 'bg-orange-100 text-orange-800',
    'karaoke': 'bg-pink-100 text-pink-800',
    'acoustic': 'bg-amber-100 text-amber-800',
    'cover': 'bg-indigo-100 text-indigo-800',
    'remix': 'bg-red-100 text-red-800',
    'other': 'bg-gray-100 text-gray-800'
  };
  return colors[type] || 'bg-gray-100 text-gray-800';
};